import React, {useEffect, useState} from 'react';
import {
    Alert,
    Button,
    Col,
    ConfigProvider,
    Form,
    Input,
    Modal,
    Row,
    Table,
    Tag,
    Upload,
    UploadFile,
    UploadProps
} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import 'dayjs/locale/es';
import locale from "antd/es/locale/es_ES";
import {ColumnsType, TableProps} from "antd/es/table";
import AlumneCasal from "../../../model/inscripcions/AlumneCasal";
import {useParams} from "react-router-dom";
import {InboxOutlined} from "@ant-design/icons";
import {PostInscripcioIdAlumneId} from "../../../dao/inscripcions/PostInscripcioIdAlumneId";
import {BsEye} from "react-icons/bs";
import {GetInscripcionsIdActivitatsIdDocuments} from "../../../dao/inscripcions/GetInscripcionsIdActivitatsIdDocuments";
import Document from "../../../model/inscripcions/Document";
import {
    GetInscripcionsIdActivitatsIdDescarregues
} from "../../../dao/inscripcions/GetInscripcionsIdActivitatsIdDescarregues";
import FileListDetail from "../../../model/inscripcions/FileListDetail";
import {randomInt} from "node:crypto";
import {GetInscripcionsIdDocumentsIdDownload} from "../../../dao/inscripcions/GetInscripcionsIdDocumentsIdDownload";
import toast from "react-hot-toast";
import {GetInscripcionsIdAlumneIdDocuments} from "../../../dao/inscripcions/GetInscripcionsIdAlumneIdDocuments";

interface PagadorModalProps {
    element: any; // Cambiado a tipo any para aceptar cualquier tipo de elemento
    visible: boolean;
    page: string,
    onClose: (value: boolean) => void,
    documents: UploadFile[],
    idInsc: string,
}

const InscripcioModalDocumentacio: React.FC<PagadorModalProps> = ({element, visible, onClose, page, documents, idInsc}) => {
    const [form] = Form.useForm();
    const {id_inscripcio} = useParams();
    const [options, setOptions] = useState<Document[]>([]);
    const [options2, setOptions2] = useState<UploadFile[]>([]);
    const [isSend, setIsSend] = useState(false);
    const [setmanesDisabled, setSetmanesDisabled] = useState<boolean>();
    const [activitat, setActivitat] = useState(0);
    const [casal, setCasal] = useState(0);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setSetmanesDisabled(activitat === 0);
        checkDades();
    }, [idInsc]);

    async function checkDades() {
        const dds = await GetInscripcionsIdActivitatsIdDocuments(idInsc, element.id_activitat+"", page);
        const dds2 = await GetInscripcionsIdActivitatsIdDescarregues(idInsc, element.id_activitat+"", page);
        //const dds3 = await GetInscripcionsIdAlumneIdDocuments(id_inscripcio + " ", element.id_alumne_casal+"", page);
        //console.log(">>>>"+JSON.stringify(dds2));
        setOptions(dds);
        setOptions2(dds2.fileList);
        //setDocs(dds3.fileList);
        //console.log(JSON.stringify(dds3.fileList));
    }
    async function handleSubmit () {
        setIsSend(true);
        const formData = form.getFieldsValue();

        console.log("Form Data con setmanes reorganizados:", formData);
        console.log(JSON.stringify(formData));
        await PostInscripcioIdAlumneId(idInsc+"", element.id_alumne_casal+"", page, formData);
        onClose(true);
        setIsSend(false);
    };


    const handleCancel = () => {
        onClose(false);
    };

    const apiUrl = process.env.REACT_APP_API_URL;
    const {Dragger} = Upload;
    const props: UploadProps = {
        name: 'files',
        method: 'POST',
        defaultFileList: documents,
        multiple: true,
        action: `${apiUrl}:8071/inscripcions/${idInsc}/alumne/${element.id_alumne_casal}/document`,
        headers: {
            'pantalla': `${page}`
        },
        /*
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },*/
    };

    const tableProps: TableProps<Document> = {
        loading
    };

    const onChange: TableProps<Document>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            //console.log('params', pagination, filters, sorter, extra);
        };


    const columns: ColumnsType<Document> = [
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {
            key: 'descripcio',
            title: 'Descripció',
            dataIndex: 'descripcio',
            width: 30,
        },
        {
            key: 'obligatori',
            title: 'Tipus',
            dataIndex: 'obligatori',
            width: 30,
            render: (estat, ele) => (
                <Tag color={ele.obligatori === 1? "red" : "geekblue"} >{ele.obligatori === 1 ? "OBLIGATORI!" : "OPCIONAL"}</Tag>
            )
        }
    ];

    async function downloadFile(file: any) {
        const blob = await GetInscripcionsIdDocumentsIdDownload(idInsc+"", file.uid, page);
        if (blob && blob.size > 0) {
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', file.name);
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
        } else {
            toast.error("Fitxer no trobat...");
        }
    }

    const props2: UploadProps = {
        showUploadList: {
            showDownloadIcon: true,
            downloadIcon: 'Descarregar',
            showRemoveIcon: false,
        },
        onDownload: downloadFile
    };

    return (
        <ConfigProvider locale={locale}>
        <Modal
            title="DOCUMENTS NECESARIS"
            visible={visible}
            onCancel={handleCancel}
            footer={[]}
            maskClosable={false}
            width={"80%"}
        >
            <Form.Item label={"ID usuari"}><Input disabled={true} value={element.id_alumne_casal}/></Form.Item>
            <Form form={form} initialValues={element} onFinish={handleSubmit}>

                {options2.length > 0 && (
                    <>
                        <h6>DESCÀRREGA DE DOCUMENTS</h6>
                        <hr/>
                        <Alert type={"warning"}
                               message={"Aquests son els documents necessaris per formalitzar la inscripció. Prem el botó Descarregar."}/>
                        <br/>
                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                <Upload {...props2}
                                    //action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                                        listType="picture"
                                        defaultFileList={[...options2]}
                                >
                                </Upload>
                            </Col>
                        </Row>
                    </>
                )}
                <br/>
                <br/>
                <h6>DESCRIPCIÓ DE DOCUMENTACIÓ</h6>
                <hr/>
                <Alert type={"warning"}
                       message={<b>Els documents marcats com a <Tag color={"red"}>OBLIGATORI!</Tag>s'han de pujar a
                           l'inscripció.</b>}/>
                <br/>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Table
                            size={"small"}
                            {...tableProps}
                            columns={columns}
                            dataSource={options}
                        />
                    </Col>
                </Row>
                <h6>CÀRREGA DE DOCUMENTS</h6>
                <hr/>
                <Alert type={"warning"}
                       message={"Puja tots els documents necessaris. Pots descarregar els documents de la inscripció adalt de tot."}/>
                <br/>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Form.Item name="files">
                            <Dragger  {...props}>
                                <p className="ant-upload-drag-icon">
                                    <InboxOutlined/>
                                </p>
                                <p className="ant-upload-text">Clica o arrossega els fitxers a aquesta zona</p>
                                <p className="ant-upload-hint">Soport per a pujar un o diversos fitxers a
                                    l'hora.</p>
                            </Dragger>
                        </Form.Item>
                    </Col>
                </Row>
                <hr/>
                <Row gutter={[16, 16]}>
                    <Col span={4}>
                        <Form.Item wrapperCol={{offset: 0, span: 16}}>
                            <Button title={"Documentació"} htmlType={"submit"}
                                    style={{backgroundColor: Colors.colors.color6}}><BiCheck/> CONFIRMAR</Button>
                        </Form.Item>
                    </Col>
                    <Col span={1}>
                    </Col>
                    <Col span={2}>
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color3}}
                                onClick={handleCancel}><BiX/> CANCELAR</Button>
                    </Col>
                </Row>
            </Form>
        </Modal>
        </ConfigProvider>
    );
};

export default InscripcioModalDocumentacio;
